import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

import Col from '../../atoms/Layout/Col/Col';
import Row from '../../atoms/Layout/Row/Row';
import LeftMenuLayout from '../../atoms/LeftMenuLayout/LeftMenuLayout';
import { getIconPath } from '../../Functions/GetIconPath';
import { setLeftMenuShown } from '../../redux/reducers/appReducer';
import { useAppDispatch } from '../../redux/store';
import TopBarComponent from '../Navigational/TopBarComponent';

const SettingsLayout: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setLeftMenuShown(false));
    }, [dispatch]);

    const navItems = [
        {
            title: t('settings.layout.general'),
            icon: getIconPath('ico_cog'),
            path: '/general',
            active: getIconPath('ico_cog_active')
        },
        /*{
            title: t('settings.layout.technology'),
            icon: getIconPath('tech'),
            path: '/tech',
            active: getIconPath('tech_active')
        },*/
        {
            title: t('settings.layout.experimental'),
            icon: getIconPath('experimental'),
            path: '/experimental',
            active: getIconPath('experimental_active')
        },
        {
            title: t('settings.layout.language'),
            icon: getIconPath('flag', '.svg', 'settings'),
            path: '/language',
            active: getIconPath('flag_active', '.svg', 'settings')
        },
        {
            title: t('settings.layout.back'),
            icon: getIconPath('arrow_back'),
            path: '../'
        }
    ];

    return (
        <>
            <Row>
                <Col className="main-col" height="100vh">
                    <Row height='auto'>
                        <TopBarComponent />
                    </Row>
                    <Row style={{ position: 'relative', backgroundColor: '#F0F0F0' }}>
                        <LeftMenuLayout
                            leftMenuItems={navItems.map((i) => ({
                                title: i.title,
                                icon: i.icon,
                                iconActive: i.active,
                                onClick: () => {
                                    if (i.path === '../') {
                                        dispatch(setLeftMenuShown(false));
                                    }
                                    if (location.pathname !== `/settings${i.path}`) navigate(`/settings${i.path}`);
                                },
                                active: location.pathname.startsWith(`/settings${i.path}`),
                        }))} 
                        >
                            <Outlet />
                        </LeftMenuLayout>
                    </Row>
                </Col>
            </Row>
        </>
    );
}

export default SettingsLayout;